// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_result_commentary-module__wrapper--3Ppm5"};